import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { doClearError, selectError } from 'app/store/error';
import { AppErrorOverlay } from './AppErrorOverlay.jsx';

const mapStateToProps = createStructuredSelector({
    error: selectError
});

const mapDispatchToProps = {
    onDismissError: doClearError
};

export const AppErrorOverlayContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AppErrorOverlay);
